import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import "../../../../assets/styles/audio-question.css";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";

export default function WebFillInTheBlankSentence({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;
    
    const [answer, setAnswer] = useState({});

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setAnswer({});
    }, [question]);

    const handleSetAnswer = (name, value) => {
        let ans = {};
        ans[name] = value.trim();
        const newAnswer = { ...answer, ...ans };
        setAnswer(newAnswer);

        let canProceed = false;
        Object.keys(newAnswer).map((keys) => {
            if(newAnswer[keys] !== "" && newAnswer[keys] !== null) {
                canProceed = true;
            }
            return null;
        });
        
        onAnswer({
            canProceed,
            answer: newAnswer,
        });
    };

    return (
        <Box
            sx={{
                display: "flex",
                backgroundColor: "white",
                flexDirection: "column",
                alignItems: "center",
                padding: "20px",
                width: "1000px",
            }}
        >
            <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="center"
                sx={{
                    width: "1000px",
                }}
            >
                {questionData?.questionList[0].map((item, index) => {
                    if (item.type === "text") {
                        return (
                            <Grid item key={index}>
                                <Typography
                                    sx={{
                                        fontSize: "32px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {item.value}
                                </Typography>
                            </Grid>
                        );
                    } else if (item.type === "textbox") {
                        return (
                            <Grid item key={index}>
                                <input
                                    name={item.name}
                                    size="small"
                                    value={answer[item.name] || ""}
                                    onChange={(e) =>
                                        handleSetAnswer(
                                            item.name,
                                            e.target.value
                                        )
                                    }
                                    style={{
                                        fontSize: "32px",
                                        padding: "5px",
                                        height: "40px",
                                        textAlign: "center",
                                        boxSizing: "border-box",
                                        width: "3.4em",
                                        outline: "none",
                                        border: "none",
                                        borderBottom: "2px solid #888888",
                                        lineHeight: "30px",
                                    }}
                                />
                            </Grid>
                        );
                    }
                    return null;
                })}
            </Grid>

            {/* Render the question image if provided */}
            {questionData?.questionImage && (
                <Box mt={3}>
                    <Box component="img"
                        src={`${imagesResources}${data.image}`}
                        alt="question"
                        style={{ maxWidth: "100%" }}
                    />
                </Box>
            )}
        </Box>
    );
};
